export default __webpack_public_path__ + "static/media/Pano copy.184bb8ad.jpg";